export const PLANNER_TYPE = "PLANNER_TYPE";

export const UpdateType = (val) => {
    return {
        type: PLANNER_TYPE,
        value: val
    };
};
